module.exports = __webpack_public_path__ + "img/con5.32ff8882.png";